/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const onUpdateMeetingControl = /* GraphQL */ `
    subscription OnUpdateMeetingControl($meetingId: ID) {
        onUpdateMeetingControl(meetingId: $meetingId) {
            meetingId
            eventId
            topic
            startDateTime
            presenters {
                meetingOrganizationId
                organizationId
                name
                attendees {
                    attendeeId
                    firstName
                    lastName
                    title
                    phoneNumber
                    meetingAttendeeId
                    status
                    joinMethod
                    meetingAttendeeNote
                    isLate
                    issues
                }
                chaperones {
                    username
                    firstName
                    lastName
                }
            }
            participants {
                meetingOrganizationId
                organizationId
                name
                attendees {
                    attendeeId
                    firstName
                    lastName
                    title
                    phoneNumber
                    meetingAttendeeId
                    status
                    joinMethod
                    meetingAttendeeNote
                    isLate
                    issues
                }
                chaperones {
                    username
                    firstName
                    lastName
                }
            }
            supports {
                meetingOrganizationId
                organizationId
                name
                attendees {
                    attendeeId
                    firstName
                    lastName
                    title
                    phoneNumber
                    meetingAttendeeId
                    status
                    joinMethod
                    meetingAttendeeNote
                    isLate
                    issues
                }
                chaperones {
                    username
                    firstName
                    lastName
                }
            }
            hosts {
                meetingOrganizationId
                organizationId
                name
                attendees {
                    attendeeId
                    firstName
                    lastName
                    title
                    phoneNumber
                    meetingAttendeeId
                    status
                    joinMethod
                    meetingAttendeeNote
                    isLate
                    issues
                }
                chaperones {
                    username
                    firstName
                    lastName
                }
            }
            connections {
                meetingConnectionId
                type
                connectionNotes
                connectionStatus
                embedCodeId
                connectionId
                name
                showcasePagePath
                knovioName
                connectionLink
                connectionHostKey
                showcaseName
                hostLink
                sip
                accountName
                errorMessage
                draft
                podiumLink
                podiumAccessCode
            }
            requestedTime
        }
    }
`;
export const onUpdateMeetingConnection = /* GraphQL */ `
    subscription OnUpdateMeetingConnection($meetingConnectionId: ID) {
        onUpdateMeetingConnection(meetingConnectionId: $meetingConnectionId) {
            meetingConnectionId
            type
            connectionNotes
            connectionStatus
            embedCodeId
            connectionId
            name
            showcasePagePath
            knovioName
            connectionLink
            connectionHostKey
            showcaseName
            hostLink
            sip
            accountName
            errorMessage
            draft
            podiumLink
            podiumAccessCode
        }
    }
`;
export const onUpdateRoom = /* GraphQL */ `
    subscription OnUpdateRoom($roomId: ID) {
        onUpdateRoom(roomId: $roomId) {
            roomId
            eventId
            roomName
            connections {
                meetingConnectionId
                type
                connectionNotes
                connectionStatus
                embedCodeId
                connectionId
                name
                showcasePagePath
                knovioName
                connectionLink
                connectionHostKey
                showcaseName
                hostLink
                sip
                accountName
                errorMessage
                draft
                podiumLink
                podiumAccessCode
            }
            requestedTime
        }
    }
`;
export const onUpdateAssetMetadata = /* GraphQL */ `
    subscription OnUpdateAssetMetadata($assetMetadataId: ID!) {
        onUpdateAssetMetadata(assetMetadataId: $assetMetadataId) {
            assetMetadataId
            objectKey
            objectUrl
            assetName
            alias
            assetType
            size
            uploadedBy
            eventId
            uploadDateTime
            status
            resolution
            recordingType
        }
    }
`;
export const onSyncEvent = /* GraphQL */ `
    subscription OnSyncEvent($eventId: Int!) {
        onSyncEvent(eventId: $eventId) {
            id
            eventId
            body
            type
            dateTime
        }
    }
`;
export const onPopulateAggregatedAttendeeLiveCounters = /* GraphQL */ `
    subscription OnPopulateAggregatedAttendeeLiveCounters($meetingId: Int) {
        onPopulateAggregatedAttendeeLiveCounters(meetingId: $meetingId) {
            active
            departures
            meetingId
            total
        }
    }
`;
export const onPassportBackgroundGenerationCompleted = /* GraphQL */ `
    subscription OnPassportBackgroundGenerationCompleted($eventId: Int!) {
        onPassportBackgroundGenerationCompleted(eventId: $eventId) {
            eventId
            imageUrl
            objectKey
        }
    }
`;
export const onMeetingsCreateDataGenerationCompleted = /* GraphQL */ `
    subscription OnMeetingsCreateDataGenerationCompleted($identifier: String) {
        onMeetingsCreateDataGenerationCompleted(identifier: $identifier) {
            identifier
            aiResponse {
                startDateTime
                endDateTime
                type
                topic
                meetingAccess
                status
                presenters {
                    organizationId
                    name
                    attendees {
                        attendeeId
                        email
                        firstName
                        lastName
                    }
                }
                participants {
                    organizationId
                    name
                    attendees {
                        attendeeId
                        email
                        firstName
                        lastName
                    }
                }
                supports {
                    organizationId
                    name
                    attendees {
                        attendeeId
                        email
                        firstName
                        lastName
                    }
                }
                hosts {
                    organizationId
                    name
                    attendees {
                        attendeeId
                        email
                        firstName
                        lastName
                    }
                }
                registrants {
                    organizationId
                    name
                    attendees {
                        attendeeId
                        email
                        firstName
                        lastName
                    }
                }
            }
        }
    }
`;
